import React from 'react'
import createG2 from 'g2-react'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
// import _values from 'lodash/values'
import _get from 'lodash/get'
// import _set from 'lodash/set'
// import _keys from 'lodash/keys'
// import _find from 'lodash/find'
import _sortBy from 'lodash/sortBy'
import moment from 'moment'
// import { COLORS } from './styles'
import config from '~/config'
// const colors = _values(config.ui.colors)

// TODO: use id instead of name and set alias

const ForcingDataChart = ({ dataRecords, dataTypeIds, category, view: { mode, daysOffset }, data: { now } }) => {
  const startDate = moment(now).subtract({ days: 7 }).format('YYYY-MM-DD@HH:mm:ss')
  const endDate = moment(now).format('YYYY-MM-DD@HH:mm:ss')
  const categoryConfig = _get(config, 'app.categories', []).find(cat => cat.id === category.id)
  const chartType = _get(categoryConfig, 'chart', 'line')
  // const dataTypes = _keys(dataRecords.reduce((result, rec) => ({
  //   ...result,
  //   [rec.type.name]: 1
  // }), {}))
  // const dataValues = _values(dataRecords.reduce((result, rec) => {
  //   // console.log(rec.observedTimestamp)
  //   // _set(result, [rec.observedTimestamp, rec.type.name], rec.value)
  //   _set(result, [rec.observedTimestamp, rec.type.name], rec.value)
  //   _set(result, [rec.observedTimestamp, 'observedTimestamp'], moment(rec.observedTimestamp).format('YYYY-MM-DD@HH:mm:ss'))
  //   // _set(result, [rec.observedTimestamp, 'observedTimestampISO'], moment(rec.observedTimestamp).toISOString())
  //   return result
  // }, {}))
  const dataSource = _sortBy(dataRecords, ['observedTimestamp'])
    .map(({ typeName, value, observedTimestamp }) => ({
      typeName,
      value,
      observedTimestamp: moment(observedTimestamp).format('YYYY-MM-DD@HH:mm:ss')
    }))
  // let observedTimestamp

  const Line = createG2(chart => {
    chart[chartType]().position(`observedTimestamp*value`).color('typeName',['#1A275B','##275B1A','#5B1A27']) // .color(colors[i]).shape('spline').size(2)
    let prevDate
    chart.axis('observedTimestamp', {
      formatter: (dateTime, item, index) => {
        const $dateTime = moment(dateTime, 'YYYY-MM-DD@HH:mm:ss', true)
        if (!$dateTime.isSame(prevDate, 'day')) {
          prevDate = $dateTime
          // return $dateTime.format('YYYY-MM-DD')
          return $dateTime.format('MMM DD')
        }
        prevDate = $dateTime
        return $dateTime.format('HH:mm:ss')
      },
      labels: {
        label: {
          textAlign: 'right',
          fontSize: 8,
          textBaseline: 'top',
          rotate: -45 * Math.PI / 180
        },
        autoRotate: false
      },
      labelOffset: 0,
      title: false
    })
    chart.col('observedTimestamp', {
      nice: true,
      tickCount: 22,
      min: startDate,
      max: endDate
    })
    // chart.legend(true)
    // chart.legend('left')
    chart.legend('typeName', {
      position: 'left',
      title: false
    })
    chart.axis('value', {
      title: false
    })
    chart.render()
  })
  return <Line data={dataSource}
    width={_get(config, 'ui.chartWidth')}
    height={_get(config, 'ui.chartHeight')}
    plotCfg={{
      margin: [10, 10, 70, 160]
    }}
  />
}
export default compose(
  inject('data'),
  inject('view'),
  observer
)(ForcingDataChart)



// WEBPACK FOOTER //
// ./src/modules/Monitoring/ForcingDataChart.js